import activity from './activity.js'
import sports from './sports.js'
import common from './common.js'
import user from './user.js'
import hp from './huangpu.js'
import family from './family.js'
import bainian from './bainian.js'
import lottery from './lottery.js'
import unions from './unions.js'
import other from './other.js'
import sport2022 from './sport2022.js'
import xuhui from './xuhui.js'
import daduan from './daduan.js'
import jd from './jd.js'


export default [
    ...activity,
		...unions,
		...other,
    ...sports,
    ...common,
    ...user,
    ...hp,
    ...family,
    ...bainian,
    ...lottery,
		...sport2022,
    ...xuhui,
    ...daduan,
    ...jd
];
